import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class CustomerApprovedExpenseReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestedFromPickupDate: moment().toDate(),
            requestedToPickupDate: moment().toDate(),
            isLoading: false,
            getCustomerJobReportUrl: '/api/v1/portal/portal-admin/customer-all-jobs-report',
            CustomerJobsReportData: [],
            downloadReportName: 'Customer All Jobs Report',
            selectedCustomers: [],
            customers: [],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleRequestedFromPickupDateChange = this.handleRequestedFromPickupDateChange.bind(this);
        this.handleRequestedToPickupDateChange = this.handleRequestedToPickupDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];
        return fetch(this.state.url, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
            },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                response.map((customer) => {
                    options.push({
                        label: customer.company.short_name + '-' + customer.name,
                        value: customer.id
                    });
                });
                this.setState({
                    customers: options,
                    isLoading: false
                });
            });
        });
    }
    handleRequestedFromPickupDateChange(date) {
        this.setState({ requestedFromPickupDate: date })
    }
    handleRequestedToPickupDateChange(date) {
        this.setState({ requestedToPickupDate: date })
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({ selectedCustomers });
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({ isLoading: true });
        let url = this.state.getCustomerJobReportUrl;
        return fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
            },
            body: JSON.stringify({
                customer_ids: this.state.selectedCustomers,
                requested_pickup_date_from: moment(this.state.requestedFromPickupDate).format("YYYY-MM-DD"),
                requested_dropoff_date_to: moment(this.state.requestedToPickupDate).format("YYYY-MM-DD"),
            }),
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                this.setState({
                    CustomerJobsReportData: response,
                    isLoading: false
                })
            });
        });
    }
    download(filename, text) {
        filename = filename + ' From ' + moment(this.state.requestedFromPickupDate).format("YYYY-MM-DD") + ' To ' + moment(this.state.requestedToPickupDate).format("YYYY-MM-DD") + '.csv';
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    render() {
        let customerJobs = [];
        const { selectedCustomers } = this.state;
        let downloadableCsvDataInvoiced = "REQUESTED DATE, REQUESTED PICKUP TIME, REQUESTED DROPOFF TIME, SCHEDULED DATE, SCHEDULED PICKUP TIME, SCHEDULED DROPOFF TIME, CUSTOMER, JOB CREATED DATE, STATUS, JOB REF, REG/VIN, TO POST CODE, FROM POST CODE, SUBCONTRACTED TO, DRIVER, 	DRIVER STATUS\n";
        if (this.state.CustomerJobsReportData.length > 0) {
            this.state.CustomerJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/" + currentJob.id;
                if (customerJobs) {
                    customerJobs.push(
                        <tr key={index}>
                            <td>{(currentJob.requested_date?currentJob.requested_date:'')}</td>
                            <td>{(currentJob.pickup_time?currentJob.pickup_time:'')}</td>
                            <td>{(currentJob.dropoff_time?currentJob.dropoff_time:'')}</td>
                            <td>{(currentJob.scheduled_date?currentJob.scheduled_date:'')}</td>
                            <td>{(currentJob.scheduled_pickup_time?currentJob.scheduled_pickup_time:'')}</td>
                            <td>{(currentJob.scheduled_dropoff_time?currentJob.scheduled_dropoff_time:'')}</td>
                            <td>{(currentJob.customer.name ?currentJob.customer.name:'')}</td>
                            <td>{(currentJob.created_at?currentJob.created_at:'')}</td>
                            <td>{(currentJob.status?currentJob.status:'')}</td>
                            <td className="job-ref-font16"><a href={joburl}>{(currentJob.id?currentJob.id:'')}</a></td>
                            <td>{currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}</td>
                            <td>{(currentJob.dropoff_address.postcode?currentJob.dropoff_address.postcode:'')}</td>
                            <td>{(currentJob.pickup_address.postcode?currentJob.pickup_address.postcode:'')}</td>
                            <td>{(currentJob.split_parent_id?currentJob.split_parent_id:'')}</td>
                            <td>{((currentJob.driver!=null)?currentJob.driver.user.first_name + ' ' + currentJob.driver.user.last_name:'')}</td>
                            <td>{((currentJob.driver!=null)?currentJob.driver.user.account_status:'')}</td>
                        </tr>
                    );
                    downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                        (currentJob.requested_date?currentJob.requested_date:'') + ',' +
                        (currentJob.pickup_time?currentJob.pickup_time:'') + ',' +
                        (currentJob.dropoff_time?currentJob.dropoff_time:'') + ',' +
                        (currentJob.scheduled_date?currentJob.scheduled_date:'') + ',' +
                        (currentJob.scheduled_pickup_time?currentJob.scheduled_pickup_time:'') + ',' +
                        (currentJob.scheduled_dropoff_time?currentJob.scheduled_dropoff_time:'') + ',' +
                        (currentJob.customer.name?currentJob.customer.name:'') + ',' +
                        (currentJob.created_at?currentJob.created_at:'') + ',' +
                        (currentJob.status?currentJob.status:'') + ',' +
                        (currentJob.id?currentJob.id:'') + ',' +
                        (currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number) + ',' +
                        (((currentJob.dropoff_address)&&(currentJob.dropoff_address.postcode))?currentJob.dropoff_address.postcode:'') + ',' +
                        (currentJob.pickup_address.postcode?currentJob.pickup_address.postcode:'') + ',' +
                        (currentJob.split_parent_id != null ? currentJob.split_parent_id : '') + ',' +
                        ((currentJob.driver!=null)?currentJob.driver.user.first_name + ' ' + currentJob.driver.user.last_name:'') + ',' +
                        ((currentJob.driver!=null)?currentJob.driver.user.account_status:'') + ',' +
                        '' + "\n";
                }
            });
        } else {
            customerJobs.push(
                <tr key='no-records'><td colSpan="26" className='text-center'>No Records</td></tr>
            );
        }

        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Customer All Jobs Report</h2>
                    <br />
                </div>

                <div className="row">
                    <div className="col-md-2">
                        <label><h5>Requested pickup Date from:</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleRequestedFromPickupDateChange} selected={this.state.requestedFromPickupDate} />
                    </div>
                    <div className="col-md-2">
                        <label><h5>Requested pickup Date to:</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleRequestedToPickupDateChange} selected={this.state.requestedToPickupDate} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br />
                        <div>
                            <StatefulMultiSelect
                                options={this.state.customers}
                                selected={selectedCustomers}
                                onSelectedChanged={this.handleCustomerSelection}
                                overrideStrings={{
                                    selectSomeItems: "Select Customers...",
                                    allItemsAreSelected: "All Customers are Selected",
                                    selectAll: "Select All",
                                    search: "Search Customer",
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                <i className="fa fa-save"></i> Generate Customer All Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                }}>
                                <i className="fa fa-download"></i> Download Customer All Jobs Report
                            </button>
                        </div>
                    </div>
                </div>
                {/* <div class="row row-spacer-1">
                    
                </div> */}
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.CustomerJobsReportData.length} jobs found..</b></label></div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Requested Date</th>
                                        <th>Requested Pickup Time</th>
                                        <th>Requested Dropoff Time</th>
                                        <th>Scheduled Date</th>
                                        <th>Scheduled Pickup Time</th>
                                        <th>Scheduled Dropoff Time</th>
                                        <th>Customer</th>
                                        <th>Job Created Date</th>
                                        <th>Status</th>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>To post code</th>
                                        <th>From post code</th>
                                        <th>Subcontracted to</th>
                                        <th>Driver</th>
                                        <th>Driver status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ?
                                        (<tr><td colSpan="26"><span className="add-loading-text">
                                            <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                        customerJobs
                                    }
                                </tbody>
                            </table>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-customer_all_jobs_report')) {
    ReactDOM.render(
        <CustomerApprovedExpenseReport message_if_none='Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-customer_all_jobs_report')
    );
}
